export default __webpack_public_path__ + "media/transfer_window/transfer_expired-ebfa2259.png";